import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Location } from "@angular/common";
import { ApiService } from "src/app/services/api.service";
import { ErrorText } from "src/app/enums/error-text.enum";
import { ErrorType } from "src/app/enums/error-type.enum";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";
import { HttpResponse } from "@angular/common/http";

@Component({
  selector: "fury-global-lead-partner-popup",
  templateUrl: "./global-lead-partner-popup.component.html",
  styleUrls: ["./global-lead-partner-popup.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class GlobalLeadPartnerPopupComponent implements OnInit, OnDestroy {
  @ViewChild("image_one") private image_one: ElementRef;
  ngUnsubscribe = new Subject<void>();
  leadPartnerPopupContent = new FormGroup({
    coverImage: new FormControl(""),
    field3: new FormControl("", [Validators.required]),
    field4: new FormControl("", [Validators.required]),
    timeoutDuration: new FormControl("", [
      Validators.required,
      Validators.min(0),
    ]),
    status: new FormControl(),
    mobileStatus: new FormControl(),
    coverImageRemoved: new FormControl(false),
  });
  bannerImage = null;
  contentDetails: any;
  constructor(public apiservice: ApiService, public location: Location) {}

  ngOnInit(): void {
    this.getLeadPartnerPopup();
  }

  getLeadPartnerPopup() {
    this.apiservice
      .get(endpoints.settings.globalLeadPartnerPopup.getLeadPartnerPopup)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res?.body?.leadPartnerGlobalPopUpContent) {
          this.contentDetails = res.body?.leadPartnerGlobalPopUpContent;
          this.bannerImage = this.contentDetails?.coverImage;
          this.leadPartnerPopupContent.patchValue({
            field3: this.contentDetails?.field3,
            field4: this.contentDetails?.field4,
            timeoutDuration: this.contentDetails?.timeoutDuration,
            status: this.contentDetails?.status,
            mobileStatus: this.contentDetails?.mobileStatus,
          });
        }
      });
  }
  onImageUpload(event: any) {
    if (
      event.target.files[0].type === "image/jpeg" ||
      event.target.files[0].type === "image/png" ||
      event.target.files[0].type === "image/jpg"
    ) {
      let file;
      file = event.target.files[0];
      this.leadPartnerPopupContent.patchValue({ coverImage: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.bannerImage = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.leadPartnerPopupContent.get("coverImageRemoved").setValue(false);
    } else {
      this.apiservice.alert(ErrorText.ImageRestriction, "error");
    }
  }
  editContent() {
    if (this.leadPartnerPopupContent.valid) {
      const data = new FormData();
      data.append("field3", this.leadPartnerPopupContent.value?.field3);
      data.append("field4", this.leadPartnerPopupContent.value?.field4);
      data.append(
        "timeoutDuration",
        this.leadPartnerPopupContent.value?.timeoutDuration
      );
      data.append(
        "status",
        this.leadPartnerPopupContent.value?.status ? "1" : "0"
      );
      data.append(
        "mobileStatus",
        this.leadPartnerPopupContent.value?.mobileStatus ? "1" : "0"
      );
      data.append(
        "coverImageRemoved",
        this.leadPartnerPopupContent.value?.coverImageRemoved ? "1" : "0"
      );
      if (this.leadPartnerPopupContent.value?.coverImage) {
        data.append(
          "coverImage",
          this.leadPartnerPopupContent.value?.coverImage
        );
      }

      this.apiservice
        .postMultiData(
          endpoints.settings.globalLeadPartnerPopup.saveLeadPartnerPopup,
          data
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: any) => {
            if (res.body) {
              this.apiservice.alert(res.body?.message, ErrorType.Success);
            }
          },
          (err) => {
            this.apiservice.alert(err?.message, ErrorType.Error);
          }
        );
    } else {
      this.leadPartnerPopupContent.markAllAsTouched();
    }
  }
  back() {
    this.location.back();
  }
  removeImage() {
    this.leadPartnerPopupContent.get("coverImageRemoved").setValue(true);
    this.leadPartnerPopupContent.get("coverImage").setValue(null);
    this.image_one.nativeElement.value = null;
    this.bannerImage = null;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
